import React, { useState, useRef } from "react";
import classes from "./PersonalInfoMobile.module.css";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { UploadedImageWithEditAndDelete } from "../../../../../stories/UploadedImageWithEditAndDelete/UploadedImageWithEditAndDelete";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import {
  linkicon,
  trashicon,
  certificate,
  addicon,
  addicongray,
  AddImageIcon,
  cancelIcon,
  AddIconBlue,
  PdfImg,
  LinkIcon,
  TrashIconGray,
  AddImageIconDisabled,
} from "../../../../../constant/imagePath";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import CertificateInformationCard from "../../../../../stories/CertificateInformationCard/CertificateInformationCard";
import MobileEditPhotoModal from "../../../../../components/Modals/CoachFlow/OnBoarding/MobileEditPhotoModal/MobileEditPhotoModal";
import { setPersonalData } from "../../../../../store/Actions/authAction";

const PersonalInfoMobile = () => {
  const getDataFromRedux = useSelector(
    (state) => state.onBoardingReducer?.personalInfo
  );
  const history = useHistory();

  const [gender, setGender] = useState(
    getDataFromRedux?.gender
      ? getDataFromRedux?.gender
      : { label: "Male", value: "Male" }
  );
  const [fullName, setFullName] = useState(
    getDataFromRedux?.fullName ? getDataFromRedux?.fullName : ""
  );
  const [phone, setPhone] = useState(
    getDataFromRedux?.phone ? getDataFromRedux?.phone : ""
  );
  const [dateOfBirth, setDateOfBirth] = useState(
    getDataFromRedux?.dob ? getDataFromRedux?.dob : ""
  );
  const [aboutYourself, setAboutYourself] = useState(
    getDataFromRedux?.aboutYourself ? getDataFromRedux?.aboutYourself : ""
  );

  const [credentials, setCredentials] = useState("");
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const dispatch = useDispatch();

  const [focusTags, setFocusTags] = useState(
    getDataFromRedux?.focusTags ? getDataFromRedux?.focusTags : []
  );

  const [levelsTaught, setLevelsTaught] = useState(
    getDataFromRedux?.levelsTaught ? getDataFromRedux?.levelsTaught : []
  );

  const [teaches, setTeaches] = useState(
    getDataFromRedux?.teaches ? getDataFromRedux?.teaches : []
  );

  // Add Certficate States
  const certificateRef = useRef(null);
  const [certificateImg, setCertificateImg] = useState(null);
  const [certifications, setCertifications] = useState(null);
  const [certificates, setCertificates] = useState([]);
  const [expirationDate, setExpirationDate] = useState("");

  // Cover Photo States
  const coverRef = useRef(null);
  const [coverPhoto, setCoverPhoto] = useState(null);
  const [isEditingCover, setIsEditingCover] = useState(false);
  const [editedCoverPhoto, setEditedCoverPhoto] = useState(null);
  const [isOpenEditPhotoModal, setIsOpenEditPhotoModal] = useState(false);

  function addCoverPhoto() {
    coverRef.current.click();
  }
  function editCoverPhoto() {
    coverRef.current.click();
    setEditedCoverPhoto(null);
  }
  function deleteCoverPhoto() {
    setCoverPhoto(null);
    setEditedCoverPhoto(null);
  }
  const convertedActiveTab = activeTab?.includes("-")
    ? activeTab.split("-")[0] + " " + activeTab.split("-")[1]
    : activeTab;

  function saveDataIntoRedux() {
    const res = {
      ...getDataFromRedux,
      fullName,
      aboutYourself,
      focusTags,
      levelsTaught,
      teaches,
      certificates,
      gender,
    };
    dispatch(setPersonalData("personal-info", res));
  }
  return (
    <div className={[classes.PersonalInfoScreeen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Edit Profile
        </p>
      </div>
      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0"].join(" ")}>
          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Tabs
              tabsData={[
                { label: "Personal info", activeText: "personal-info" },
                { label: "Photo & video", activeText: "photo-and-video" },
                { label: "FAQ", activeText: "faq" },
              ]}
              state={{ label: convertedActiveTab }}
              setState={(item) => dispatch(setActiveTab(item?.activeText))}
            />
          </Col>

          <Col md={12} sm={12} className={`${[classes.mb32].join(" ")}`}>
            {typeof editedCoverPhoto !== "object" &&
            editedCoverPhoto !== null ? (
              <UploadedImageWithEditAndDelete
                image={editedCoverPhoto}
                editClick={() => editCoverPhoto()}
                deleteClick={() => deleteCoverPhoto()}
              />
            ) : (
              <Button
                className={classes.addImageBtn}
                icon={AddImageIcon}
                size={"Medium"}
                label={"Add cover photo"}
                onClick={() => coverRef?.current?.click()}
                disabled={editedCoverPhoto == null ? false : true}
                disabledIcon={AddImageIconDisabled}
              />
            )}

            <input
              className="d-none"
              type={"file"}
              accept="image/*"
              ref={coverRef}
              onChange={(e) => {
                setCoverPhoto(e.target.files[0]);
                setIsOpenEditPhotoModal(true);
              }}
              onClick={(event) => {
                event.target.value = null;
              }}
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Input state={fullName} setter={setFullName} label="Full Name" />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <DropDown
              options={[
                { label: "Male", value: "Male" },
                { label: "Female", value: "Female" },
                { label: "Others", value: "Others" },
              ]}
              state={gender}
              setter={setGender}
              label="Gender"
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Input
              state={phone}
              setter={setPhone}
              label="Phone number (Optional)"
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Input
              state={dateOfBirth}
              setter={setDateOfBirth}
              label="Date of Birth"
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <DropDown
              state={focusTags}
              options={[{ label: "ForeHand", value: "ForeHand" }]}
              setter={setFocusTags}
              isMulti={true}
              label="Focus tags (What part of the game can you improve your student??)"
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <DropDown
              state={levelsTaught}
              options={[{ label: "Beginner", value: "Beginner" }]}
              setter={setLevelsTaught}
              isMulti={true}
              label="Levels taught"
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <DropDown
              state={teaches}
              options={[{ label: "Kids", value: "Kids" }]}
              setter={setTeaches}
              isMulti={true}
              label="Teaches"
            />
          </Col>

          <Col md={12} className={`${[classes.mb32].join(" ")}`}>
            <Row className="gy-2 gx-2">
              <Col sm={12}>
                <DropDown
                  state={certifications}
                  options={[
                    {
                      label: "Professional Tennis Registry",
                      value: "Professional Tennis Registry",
                    },
                  ]}
                  setter={setCertifications}
                  labelTwo={"(Optional)"}
                  label={"What certifications/licenses do you hold?"}
                  placeholder="Select Certificate"
                />
              </Col>

              <Col sm={11} xs={10}>
                <Input
                  placeholder={"Expiration Date"}
                  state={expirationDate}
                  setter={setExpirationDate}
                />
              </Col>
              <Col sm={1} xs={2}>
                <Button
                  icon={LinkIcon}
                  customStyle={{ width: "48px", height: "48px" }}
                  onClick={() => {
                    certificateRef.current.click();
                  }}
                />
              </Col>
              {/* Render Certificates */}
              {certificates.map((item) => {
                return (
                  <Col md={12} key={item?._id}>
                    <CertificateInformationCard
                      data={item}
                      onDelete={() => {
                        const newArr = [...certificates];
                        const index = newArr.findIndex((d) => d._id);
                        newArr.splice(index, index + 1);
                        setCertificates(newArr);
                      }}
                    />
                  </Col>
                );
              })}

              {/* Add Certficate */}
              <Col
                md={12}
                className={`${[classes.mb16, classes.mt16].join(" ")}`}
              >
                <LinkButtonWithIcon
                  primary={true}
                  text={"Add certificate"}
                  leftIcon={AddIconBlue}
                  disabled={
                    certifications == null ||
                    expirationDate == "" ||
                    certificateImg == null
                      ? true
                      : false
                  }
                  onClick={() => {
                    const newArr = [...certificates];
                    console.log({ certificateImg });
                    newArr.push({
                      _id: Math.floor(Math.random() * 10000),
                      title: certifications?.label,
                      size: Math.ceil(certificateImg?.size / (1024 * 1024)),
                      date: expirationDate,
                      certificateImg: certificateImg,
                    });
                    setCertificates(newArr);
                    setCertifications(null);
                    setExpirationDate("");
                    setCertificateImg(null);
                  }}
                />
              </Col>
            </Row>
          </Col>
          {/* Hidden Input For Certificate Img */}
          <input
            type={"file"}
            ref={certificateRef}
            className={"d-none"}
            accept="image/png, image/jpeg, application/pdf"
            onChange={(e) => setCertificateImg(e.target.files[0])}
            onClick={(event) => {
              event.target.value = null;
            }}
          />

          <Col md={12} className={[classes.mb56].join(" ")}>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
                fontSize: "24px",
                lineHeight: "32px",
              }}
              className={`${classes.mb32}`}
            >
              About You
            </h3>
            <TextArea
              placeholder=""
              label="Tell a little about yourself. What makes you a great coach?"
              state={aboutYourself}
              setter={setAboutYourself}
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <h3
              style={{
                ...Fonts.h3,
                color: Colors.neutralShadesOfNero,
                fontSize: "24px",
                lineHeight: "32px",
              }}
              className={`${classes.mb32}`}
            >
              Credentials and Experience
            </h3>
            <TextArea
              placeholder=""
              label="What is your area of expertise?"
              state={credentials}
              setter={setCredentials}
            />
          </Col>

          <Col sm={12} className={`${classes.mb32}`}>
            <LinkButtonWithIcon
              customStyle={{
                ...Fonts.b2,
                fontSize: "14px",
                lineHeight: "20px",
              }}
              primary={true}
              text="Add more"
              leftIcon={AddIconBlue}
              disabled={true}
            />
          </Col>

          <Col xs={12}>
            <Button
              customStyle={{ width: "100%", height: "56px" }}
              primary={true}
              size="Large"
              onClick={saveDataIntoRedux}
            >
              Save changes
            </Button>
          </Col>
        </Row>
      </Container>
      {coverPhoto !== null && (
        <MobileEditPhotoModal
          show={isOpenEditPhotoModal}
          setShow={setIsOpenEditPhotoModal}
          state={coverPhoto}
          onSave={setEditedCoverPhoto}
        />
      )}
    </div>
  );
};
export default PersonalInfoMobile;
